<div id="academy-courses" class="page-layout simple">

    <!-- HEADER -->
    <div class="header primary p-16 p-sm-24" fxLayout="column" fxLayoutAlign="center center">

        <div class="hero-text">
            <!-- <mat-icon [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}" class="hero-icon">school</mat-icon> -->
            <h1 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                <!--{{producto.welcome | translate}}-->
                {{ titleProducto | translate}}
            </h1>
        </div>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content p-24">

        <div fxLayout="column" fxLayoutAlign="center">
            <div class="courses" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">

                <!--<ng-container *ngIf="origen.producto == 1 && instituto == 'MX'; else videoLandWW">
                <div *ngIf="validarVideo==true" class="course" fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                  <video src="{{video1Mx}}" poster="{{video1MxPoster}}" controlslist="nodownload" controls fxFlex="48" fxLayoutAlign="center center" [@animate]="{value:'*',params:{delay:'500ms', y:'25px'}}"></video>
                  <video src="{{video2Mx}}" poster="{{video2MxPoster}}" controlslist="nodownload" controls fxFlex="48" fxLayoutAlign="center center" [@animate]="{value:'*',params:{delay:'500ms', y:'25px'}}"></video>
                </div>
              </ng-container>-->
                <!--<ng-template #videoLandWW>
                <div *ngIf="validarVideo==true" class="course" fxFlex="100" fxFlex.gt-sm="66"  [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                  <video id="videoLanding" [@animate]="{value:'*',params:{delay:'500ms', y:'25px'}}" src="" controlslist="nodownload" controls fxFlex="100" fxLayoutAlign="center center" poster=""></video>
                </div>
              </ng-template>-->

                <!-- <div class="no-productos" *ngIf="productosAsignados.length === 0">
              No courses found!
            </div> -->
                <ng-container *ngIf="cargando">
                    <div fxFlex="100" fxFlex.gt-sm="33" fxLayout="column" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                        <div fxLayout="column" fxLayoutAlign="space-between center">
                            <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                            <h2>{{'WIZARD.CARGANDO' | translate}}</h2>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="!cargando">
                    <div *ngIf="productosAsignados.length == 0" class="statusDiv" fxFlex="100" fxFlex.gt-sm="33" fxLayout="column" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                        <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                            <h2>{{'WIZARD.SINPRODS' | translate}}</h2>
                            <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                        </div>
                    </div>

                    <div *ngFor="let producto of productosAsignados; let i = index; let last = last; let first = first;" class="course" fxFlex="100" fxFlex.gt-sm="33" [ngClass]="web" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">

                        <div class="cursoCard" fxFlex="100" [ngClass]="producto.category" [@animate]="{value:'*',params:{y:'100%'}}" style="padding-right: 10px;">
                            <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                                <div class="header primary" fxLayout="row" fxLayoutAlign="center center">
                                    <!--<div class="category" fxFlex>{{producto.tagStatus | translate}}</div>-->
                                    <div class="category" fxFlex></div>
                                </div>

                                <div class="content  p-20 m-20" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                                    <div class="h1">{{titleProducto | translate}}</div>
                                    <div class="updated">{{'WIZARD.LANDING.DONE' | translate}}{{producto.fechaCulture}}</div>
                                </div>
                                <!--<ng-container *ngIf="itbmUser">
                                    <div class="" fxLayout="column" fxLayoutAlign="center center">
                                        <button mat-raised-button class="mb-20 accent">
                                        {{'WIZARD.EVALUADOR.TITUTLO' | translate}}
                                        <mat-icon class="ml-20">spellcheck</mat-icon>
                                      </button>
                                    </div>
                                </ng-container>-->

                                <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                                    <button mat-button class="accent rndBt" fxFlex="100" (click)="navigateTo(producto.idCulture);">{{'WIZARD.LANDING.IR' | translate}}</button>
                                </div>



                            </div>
                        </div>

                    </div>


                </ng-container>




            </div>
            <!-- / CONTENT -->

        </div>